import angular from 'angular';
import booksMenu from '../../menu/Menu';
import booksServices from '../../booksServices';
import ngRoute from 'angular-route';
import returnItems from '../../com/returnItems/returnItems';
import './returnReceipts.scss';
/** Services */
import { ReturnReceiptsService } from './services/Services';
/** Dom */
import { receiptLookupComponent } from './dom/receiptLookup';

export default angular
  .module('csm.books.returnReceipts', [
    returnItems,
    booksMenu,
    booksServices,
    ngRoute,
    'ui.grid'
  ])
  .controller('ReturnReceiptsController', Controller)
  .config(ConfigRoutes)
  .service('Services', ReturnReceiptsService)
  .component('receiptLookup', receiptLookupComponent).name;

/*******************************************************************************
 * ConfigRoutes */
/**
 * @ngdoc   config
 * @module  csm.books.returnReceipts
 * @name    csm.books.returnReceipts.config:ConfigRoutes
 * @description
 * Set up the routes for the application.
 *******************************************************************************/
/* @ngInject */ function ConfigRoutes($routeProvider, $locationProvider) {
  $locationProvider.hashPrefix('');
  var resolve = {
    returnRoute: function () {
      return '/';
    }
  };

  $routeProvider
    .when('/', { template: '<receipt-lookup>', resolve: resolve })
    .when('/receiptItems/:id', {
      template: '<return-items return-route="$resolve.returnRoute">',
      resolve: resolve
    })
    .otherwise({ redirectTo: '/' });
}

/*******************************************************************************
 * Controller
 *******************************************************************************/
/* @ngInject */ function Controller($appFlags, $rootScope) {
  $rootScope.appFlags = $appFlags;
}
